'use client'

import { canViewSupplier, getEmailFromUseridCookie } from '@/src/utils/generalUtils/supplierAccess'
import { getCookie } from '@/src/utils/browser'
import { useEffect, useState } from 'react'

/**
 * Whether this viewer may see fare suppliers.
 *
 * Resolved after mount rather than during render: the cookie is unreadable on the server, so
 * reading it inline would render `false` there and `true` on the client, and React would flag
 * the mismatch.
 */
export const useCanViewSupplier = (): boolean => {
    const [allowed, setAllowed] = useState(false)

    useEffect(() => {
        setAllowed(canViewSupplier(getEmailFromUseridCookie(getCookie('userid'))))
    }, [])

    return allowed
}

export default useCanViewSupplier
